"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FoundersNotesHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-section" className="bg-background py-24 md:py-32 lg:py-48 relative overflow-hidden flex items-center justify-center min-h-[70vh]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_70%)] opacity-40 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-default text-[var(--color-green-accent)] text-xl md:text-2xl mb-6 block tracking-wide">
            Real insights. Real protocols. Real life.
          </span>

          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl tracking-tight text-foreground mb-8">
            Founder's Notes
          </h1>

          <Separator className="w-16 md:w-24 bg-[var(--color-green-accent)]/40 h-[1px] mb-10" />

          <p className="font-serif text-lg md:text-xl lg:text-2xl text-muted-foreground leading-relaxed mb-10 max-w-2xl">
            A space where I share my thoughts, insights, studies, and real experiences in wellness, business, and optimization.
          </p>

          <div className="w-full max-w-4xl mb-12 rounded-lg overflow-hidden shadow-lg border border-border/50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/kccc.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/kccc.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/kccc.png-wvc-sizes" alt="Founder's editorial visual" className="w-full h-auto object-cover" loading="lazy" decoding="async" />
          </div>

          <Button asChild variant="default" className="rounded-full px-10 py-7 font-default text-lg tracking-wide bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 transition-all duration-300 shadow-md">
            <Link to="#latest-notes">
              Explore the Notes
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}